import { useContext, useState } from "react";
import { MCashForceCommit, MCashStatus } from "../api/FetchAPI";
import { ApiRequest } from "../lib/interfaces/APIRequestInterface";
import { AuthContext } from "../components/AuthContextComponent";
import { MCashInfo } from "../lib/interfaces/MCashReprocessInterface";
import {
  confirmationMsg,
  generateLoading,
  showAlert,
  stopLoading,
} from "../promptMessages/PromptMessages";
import useUserLogin from "./UserLoginhook";
import { FetchErr } from "../lib/helpers/UnhandledError";
import { handleHttpError } from "../lib/helpers/HanldeHttpError";

const useReprocess = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { userInfo, username } = useContext(AuthContext);
  const { customColor } = useUserLogin();
  const [reprocessData, setReprocessData] = useState<MCashInfo[]>([]);
  const [batchNumber, setBatchNumber] = useState<string>("");
  const [isGenerating, setIsGenerating] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  const [totalDisplay, setTotalDisplay] = useState({
    totalPrincipalPHP: 0,
    totalPHP: 0,
    totalFeePHP: 0,
  });

  const themeBackground = userInfo?.theme === "DARK" ? "#24292e" : "";
  const themeTextColor = userInfo?.theme === "DARK" ? "#fafbfc" : "";

  const handleReprocessModalClick = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleReason = (toggle: boolean = true) => {
    if (!toggle) {
      setIsModalOpen(false);
      return;
    }
  };
  // handle for onChange
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.trim();

    setBatchNumber(value);
  };
  //handle for reprocess the transaction
  const handleReprocessData = async (
    batchNumber?: string,
    isDone?: (value: boolean) => void,
    IsGenerating?: (value: boolean) => void,
    isReprocessData?: (value: any) => void,
    isTotalDisplay?: (value: any) => void
  ) => {
    setReprocessData([]);
    isReprocessData
      ? isReprocessData([])
      : console.warn("isReprocessData function is not defined");

    setIsDone(false);

    isDone ? isDone(false) : console.warn("isDone function is not defined");

    const requestParams: ApiRequest = {
      userId: username,
      partnersId: userInfo?.partnersId,
      batchNumber: batchNumber,
    };

    try {
      setIsGenerating(true);

      const result: any = await MCashStatus(requestParams);

      const total = {
        totalPrincipalPHP: result.totalPrincipalPHP,
        totalPHP: result.totalPHP,
        totalFeePHP: result.totalFeePHP,
      };

      setTotalDisplay(total);

      isTotalDisplay
        ? isTotalDisplay(total)
        : console.warn("isTotalDisplay function is not defined");

      IsGenerating
        ? IsGenerating(true)
        : console.warn("IsGenerating function is not defined");

      if (result.respCode === 2000) {
        if (Array.isArray(result.mCashInfo)) {
          setReprocessData(result.mCashInfo);

          isReprocessData
            ? isReprocessData(result.mCashInfo)
            : console.warn("isReprocessData function is not defined");

          setIsGenerating(false);

          isDone
            ? isDone(true)
            : console.warn("isDone function is not defined");

          IsGenerating
            ? IsGenerating(false)
            : console.warn("IsGenerating function is not defined");

          setIsDone(true);
        } else {
          setReprocessData([]);

          setIsGenerating(false);

          IsGenerating
            ? IsGenerating(false)
            : console.warn("IsGenerating function is not defined");
        }
      } else if (result.respCode !== 2000 && IsGenerating) {
        IsGenerating
          ? IsGenerating(false)
          : console.warn("IsGenerating function is not defined");
      } else {
        showAlert("Sorry!", result.respMsg, "error", customColor);
        setIsGenerating(false);

        IsGenerating
          ? IsGenerating(false)
          : console.warn("IsGenerating function is not defined");
      }
    } catch (error) {
      // FetchErr(error, themeBackground, customColor, themeTextColor);
      handleHttpError(error, customColor);
    } finally {
      // Optionally any cleanup if needed
    }
  };
  // handle to force commit a transaction
  const handleMCashForceCommit = async (
    refno: string | [],
    batchNumber?: string,
    isDone?: (value: boolean) => void,
    IsGenerating?: (value: boolean) => void,
    isReprocessData?: (value: any) => void,
    isTotalDisplay?: (value: any) => void,
    modalClose?: any,
    rows?: any
  ) => {
    const requestParams: ApiRequest = {
      userId: username,
      partnersId: userInfo?.partnersId,
      refNoInfo: refno,
    };

    const confirm = await confirmationMsg(
      "",
      "Do you want to proceed with reprocessing these transactions to MCash?",
      "",
      "",
      customColor
    );

    if (confirm) {
      try {
        generateLoading("Please wait...");

        const result: any = await MCashForceCommit(requestParams);

        if (result.respCode === 2000) {
          stopLoading();

          setSelectedRows([]);
          rows([]);

          setIsModalOpen(false);
          modalClose(false);

          isDone
            ? isDone(true)
            : console.warn("isDone function is not defined");

          IsGenerating
            ? IsGenerating(true)
            : console.warn("IsGenerating function is not defined");

          showAlert("Sucess", result.respMsg, "success", customColor);

          //trigger the handleReprocessData

          await handleReprocessData(
            batchNumber,
            isDone,
            IsGenerating,
            isReprocessData,
            isTotalDisplay
          );
        } else {
          setIsModalOpen(false);

          isDone
            ? isDone(false)
            : console.warn("isDone function is not defined");

          showAlert("Sorry!", result.respMsg, "error", customColor);
        }
      } catch (error) {
        // FetchErr(error, themeBackground, customColor, themeTextColor);
        handleHttpError(error, customColor);
      } finally {
      }
    } else {
    }
  };

  //handle for form submission
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await handleReprocessData(batchNumber); // Pass batchNumber as an argument
  };

  // Handle individual checkbox change
  const handleCheckboxChange = (refno: string) => {
    setSelectedRows((prevSelectedRows) => {
      const updatedSelectedRows = new Set(prevSelectedRows);
      if (updatedSelectedRows.has(refno)) {
        updatedSelectedRows.delete(refno);
      } else {
        updatedSelectedRows.add(refno);
      }

      return Array.from(updatedSelectedRows); // Convert Set back to Array
    });
  };

  // Handle "select all" checkbox change
  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const allIds = reprocessData.map((row) => row.refno);
      setSelectedRows(allIds);
      setSelectAll(true); // Set selected rows to all IDs
    } else {
      setSelectedRows([]); // Clear the array
      setSelectAll(false);
    }
  };

  return {
    batchNumber,
    isDone,
    isGenerating,
    isModalOpen,
    reprocessData,
    selectAll,
    selectedRows,
    totalDisplay,
    handleMCashForceCommit,
    handleInputChange,
    handleReprocessModalClick,
    handleReason,
    handleReprocessData,
    handleCheckboxChange,
    handleSelectAll,
    handleSubmit,
    setIsModalOpen,
    setIsDone,
    setIsGenerating,
    setSelectedRows,
    setReprocessData,
    setTotalDisplay,
  };
};

export default useReprocess;
